<mat-dialog-content>
    <app-modal-title>{{ 'labels.attention' | translate }}</app-modal-title>
    @for (privilege of dialogData.privileges; track privilege.privId) {
        <p>{{ 'dialog.expiresPrivilege.message' | translate: { privilegeName: privilege.privName } }}</p>
    }
    <mat-dialog-actions class="px-0">
        <button class="mat-elevation-z0 mat-mdc-elevation-specific"
                mat-raised-button color="primary" (click)="gotIt()"
                mat-dialog-close>{{ 'app.actions.gotIt' | translate }}
        </button>
    </mat-dialog-actions>
</mat-dialog-content>


